import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { getMemberAvatar, getMemberDisplayName, getMemberTag, useFetch } from "../utils.js";
import ImageFallback from "../components/imageFallback.js";
import { printTime } from "./sanctions.jsx";

type MemberType = {
    id              : string;
    displayName     : string;
    avatar          : string | null;
};

type VoiceStats = {
    member      : MemberType;
    duration    : number;
};

export default defineComponent({

    setup() {
        const { fetch } = useFetch();
        const route = useRoute();
        const topVoice  = ref<VoiceStats[]>([]);

        onMounted(async () => {
            const roleIds = (typeof route.query["roleIds"] === "string")
                ? route.query["roleIds"].split(",")
                : undefined;

            topVoice.value = await fetch("/api/top-voice", {
                headers: {
                    "content-type": "application/json",
                },
                body    : JSON.stringify({ roleIds }),
                method  : "POST",
            }).then((res) => res.json());
        });

        return () => (
            <div id="app">
                <div class="sanction-list-viewer">
                    <div class="sanction-list" style="min-width: 0;">
                        {topVoice.value.map((voice, i) => (
                            <div class="sanction-item">
                                <div class="sanction-item-number">
                                    {i + 1}.
                                </div>

                                <router-link to={`/users/${voice.member.id}`} class="sanction-item-user" style="flex: 1 0 0">
                                    <ImageFallback class="sanction-item-user-avatar" src={getMemberAvatar(voice.member as any)} default="https://cdn.discordapp.com/embed/avatars/0.png" alt={getMemberDisplayName(voice.member as any)} />

                                    <div class="sanction-item-user-name">
                                        <div class="sanction-item-user-displayname">{getMemberDisplayName(voice.member as any)}</div>
                                        <div class="sanction-item-user-username">{getMemberTag(voice.member as any)}</div>
                                    </div>
                                </router-link>

                                <div class="sanction-item-delay">
                                    {printTime(voice.duration / 1000)}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
});
